import React, { useCallback, useEffect, useState } from "react"
import {
  // Button,
  Dialog,
  // DialogActions,
  DialogContent,
  DialogTitle,
  // FormControl,
  IconButton,
  Stack,
  // MenuItem,
  // Select,
  // Stack,
  // Typography,
} from "@mui/material"
import { cardHover, select } from "utils/sounds"
import { styles } from "./styles/SmashGameSettings.styles"
import { useTranslation } from "react-i18next"
import Image from "components/Image"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import GameItem from "pages/student/smashgames/GameItem"
import useSound from "use-sound"
import { useAuthContext } from "contexts/AuthContext"
// import { smashGamesURL } from "services/config"

export default function SmashGameSettings({
  open,
  onClose,
  title,
  item,
  onSuccess,
  fontSettings = {},
}) {
  const { audioSettings } = useAuthContext()
  const [playSelect] = useSound(select, {
    volume: 0.5,
    soundEnabled: audioSettings?.enabledAudioEffects,
    html5: false,
  })
  const { t } = useTranslation()
  const [playHover, { sound }] = useSound(cardHover, {
    interrupt: true,
    soundEnabled: audioSettings?.enabledAudioEffects,
    html5: false,
  })
  const [isPlaying, setIsPlaying] = useState(false)

  useEffect(() => {
    sound?.on("play", () => setIsPlaying(true))
    sound?.on("stop", () => setIsPlaying(false))
    sound?.on("end", () => setIsPlaying(false))
    sound?.on("pause", () => setIsPlaying(false))

    return () => {
      sound?.off("play")
      sound?.off("stop")
      sound?.off("end")
      sound?.off("pause")
    }
  }, [sound])

  const onHover = useCallback(
    (e) => {
      if (isPlaying) return
      playHover()
    },
    [playHover, isPlaying]
  )

  const openGame = useCallback(
    async (field) => {
      playSelect()
      onSuccess({
        selection: field,
      })
    },
    [item, playSelect, onSuccess]
  )

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={"md"}
      PaperProps={{
        sx: [
          styles.contanier,
          fontSettings?.fontFamily && {
            "& .MuiTypography-root, button, textarea": {
              fontFamily: fontSettings.fontFamily,
            },
          },
          fontSettings?.bgColor && {
            backgroundColor: fontSettings.bgColor,
          },
        ],
      }}
    >
      <IconButton aria-label="close" onClick={onClose} sx={styles.closeButton}>
        <ArrowBackIcon fontSize="large" color="primary" />
      </IconButton>
      <Image name="gameSmashActive" sx={styles.mainImage} />
      <DialogTitle textAlign={"center"} mt={1} sx={styles.dialogHeader}>
        {t(`smash_game`)}
      </DialogTitle>
      <DialogContent
        sx={{
          p: 0,
          py: 3.75,
        }}
      >
        <Stack
          direction={"row"}
          spacing={3}
          alignItems={"center"}
          justifyContent={"center"}
          pt={2}
          px={2}
        >
          <GameItem
            title={"individual"}
            image={"userIndividual"}
            onClick={() => openGame("individualSmashGameLink")}
            onHover={onHover}
          />
          <GameItem
            title={"challenges"}
            image={"userVersus"}
            onClick={() => openGame("challengesSmashGameLink")}
            onHover={onHover}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  )
}
